// src/actions/renameOutputFile.ts
import axiosInstance from "../utils/axiosInstance";

/**
 * Updates the display name for a file (metadata only - S3 key unchanged)
 * @param fileKey - The S3 key of the file
 * @param newDisplayName - The new display name (what users see in lists)
 */
export const renameOutputFile = async (
  fileKey: string,
  newDisplayName: string
): Promise<{ message: string; fileKey: string; newDisplayName: string }> => {
  try {
    console.log("[Action] renameOutputFile called with:", { fileKey, newDisplayName });
    const response = await axiosInstance.put(
      `/utility/rename-output-file`,
      { fileKey, newDisplayName }
    );
    console.log("[Action] renameOutputFile response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("[Action] Error renaming file:", error.response?.data || error.message);
    throw new Error(
      error.response?.data?.message || "Failed to update display name."
    );
  }
};
